import { Form, FormItem } from 'app/shared/form/form';
import { Button, Input, Radio } from 'antd';
import React, { useState } from 'react';
import { CustomModal } from 'app/shared/customModal/customModal';
import s from './index.module.scss';
import {
    AlignCenterOutlined,
    AlignLeftOutlined,
    AlignRightOutlined,
    DesktopOutlined,
    MobileOutlined,
} from '@ant-design/icons';
import { ColorRow } from 'app/modules/setting/components/rows/colorRow';
import { ChromePicker } from 'react-color';

const ColorPickerCustom = ({
    setIsColorPicker,
    isColorPicker,
    value,
    onChange,
}) => {
    const onChangeColor = (color) => {
        onChange(color.hex);
    };
    return (
        <>
            <div
                style={{
                    background: value,
                    width: '25px',
                    height: '25px',
                    borderRadius: '50%',
                }}
                onClick={() => setIsColorPicker(!isColorPicker)}
            />
            {isColorPicker && (
                <div
                    className={
                        'chrome-picker-wrapper position-absolute' +
                        ' color-picker-no-rgba'
                    }
                    style={{ top: '33px' }}
                >
                    <ChromePicker
                        color={value}
                        onChangeComplete={onChangeColor}
                    />
                </div>
            )}
        </>
    );
};
const RangePicker = ({ value, onChange }) => {
    return (
        <div>
            <input
                type="range"
                min="1"
                max="120"
                value={value}
                onChange={onChange}
            />
            <p>{value} px</p>
        </div>
    );
};
export const LendingHeaderModal = ({
    visible,
    onCancel,
    onFinish,
    initialValues,
}) => {
    const [isTitleColorPicker, setIsTitleColorPicker] = useState(false);
    const [isDescriptionColorPicker, setIsDescriptionColorPicker] =
        useState(false);
    const [isDesktop, setIsDesktop] = useState(true);
    const [isDesktopDescription, setIsDesktopDescription] = useState(true);
    const [colorHeader, setColorHeader] = useState('#333');
    const [colorDescription, setColorDescription] = useState('#333');
    const [sizeHeader, setSizeHeader] = useState('32');
    const [sizeMobileHeader, setSizeHeaderMobile] = useState('32');
    const [sizeDescription, setSizeDescription] = useState('14');
    const [sizeMobileDescription, setSizeDescriptionMobile] = useState('14');
    const onChangeTitleColor = (color) => {
        setColorHeader(color);
    };

    const onChangeDescriptionColor = (color) => {
        setColorDescription(color.hex);
    };

    const handleSliderSizeHeader = (e) => {
        setSizeHeader(e.target.value);
    };
    const handleSliderSizeHeaderMobile = (e) => {
        setSizeHeaderMobile(e.target.value);
    };

    const handleSliderSizeDescription = (e) => {
        setSizeDescription(e.target.value);
    };
    const handleSliderSizeDescriptionMobile = (e) => {
        setSizeDescriptionMobile(e.target.value);
    };
    return (
        <CustomModal
            destroyOnClose
            title={'Настроить заголовок'}
            open={visible}
            onCancel={onCancel}
            className={s.modal}
            uniqueClass="lending-header-modal-uniqueClass"
        >
            <div className="section_modal">
                <Form
                    initialValues={initialValues}
                    onFinish={onFinish}
                    className
                >
                    <FormItem label="Ссылка на изображение" name="img">
                        <Input />
                    </FormItem>

                    <div className={s.align}>
                        <FormItem name="alignImg">
                            <Radio.Group>
                                <Radio.Button value={'left'}>
                                    <AlignLeftOutlined />
                                </Radio.Button>
                                <Radio.Button value={'center'}>
                                    <AlignCenterOutlined />
                                </Radio.Button>
                                <Radio.Button value={'right'}>
                                    <AlignRightOutlined />
                                </Radio.Button>
                            </Radio.Group>
                        </FormItem>
                    </div>

                    <FormItem label="Класс для изображения" name="classNameImg">
                        <Input />
                    </FormItem>

                    <FormItem label="Заголовок" name="header">
                        <Input />
                    </FormItem>

                    <div>
                        Размер заголовка{' '}
                        {isDesktop ? (
                            <DesktopOutlined
                                onClick={() => setIsDesktop(!isDesktop)}
                            />
                        ) : (
                            <MobileOutlined
                                onClick={() => setIsDesktop(!isDesktop)}
                            />
                        )}
                        <FormItem name="sizeHeader" hidden={!isDesktop}>
                            <RangePicker
                                value={sizeHeader}
                                onChange={handleSliderSizeHeader}
                            />
                        </FormItem>
                        <FormItem name="sizeMobileHeader" hidden={isDesktop}>
                            <RangePicker
                                value={sizeMobileHeader}
                                onChange={handleSliderSizeHeaderMobile}
                            />
                        </FormItem>
                    </div>

                    <FormItem
                        label="Уникальный класс заголовка"
                        name="classNameHeader"
                    >
                        <Input />
                    </FormItem>

                    <FormItem
                        label="Цвет заголовка"
                        name="colorHeader"
                        valuePropName="value"
                    >
                        <ColorPickerCustom
                            value={colorHeader}
                            onChange={(color) => onChangeTitleColor(color)}
                            setIsColorPicker={setIsTitleColorPicker}
                            isColorPicker={isTitleColorPicker}
                        />
                    </FormItem>
                    <FormItem label="Уникальный идентификатор" name="id">
                        <Input />
                    </FormItem>
                    <div className={s.align}>
                        <FormItem name="alignHeader">
                            <Radio.Group>
                                <Radio.Button value={'left'}>
                                    <AlignLeftOutlined />
                                </Radio.Button>
                                <Radio.Button value={'center'}>
                                    <AlignCenterOutlined />
                                </Radio.Button>
                                <Radio.Button value={'right'}>
                                    <AlignRightOutlined />
                                </Radio.Button>
                            </Radio.Group>
                        </FormItem>
                    </div>

                    <FormItem label="Описание" name="description">
                        <Input.TextArea style={{ minHeight: 150 }} />
                    </FormItem>
                    <div>
                        Размер описания{' '}
                        {isDesktopDescription ? (
                            <DesktopOutlined
                                onClick={() =>
                                    setIsDesktopDescription(
                                        !isDesktopDescription
                                    )
                                }
                            />
                        ) : (
                            <MobileOutlined
                                onClick={() =>
                                    setIsDesktopDescription(
                                        !isDesktopDescription
                                    )
                                }
                            />
                        )}
                        <FormItem
                            name="sizeDescription"
                            hidden={!isDesktopDescription}
                        >
                            <RangePicker
                                value={sizeDescription}
                                onChange={handleSliderSizeDescription}
                            />
                        </FormItem>
                        <FormItem
                            name="sizeMobileDescription"
                            hidden={isDesktopDescription}
                        >
                            <RangePicker
                                value={sizeMobileDescription}
                                onChange={handleSliderSizeDescriptionMobile}
                            />
                        </FormItem>
                    </div>
                    <FormItem label="Цвет описания" name="colorDescription">
                        <ColorPickerCustom
                            value={colorDescription}
                            onChange={(color) =>
                                onChangeDescriptionColor(color)
                            }
                            setIsColorPicker={setIsDescriptionColorPicker}
                            isColorPicker={isDescriptionColorPicker}
                        />
                    </FormItem>
                    <div className={s.align}>
                        <FormItem name="alignDescription">
                            <Radio.Group>
                                <Radio.Button value={'left'}>
                                    <AlignLeftOutlined />
                                </Radio.Button>
                                <Radio.Button value={'center'}>
                                    <AlignCenterOutlined />
                                </Radio.Button>
                                <Radio.Button value={'right'}>
                                    <AlignRightOutlined />
                                </Radio.Button>
                            </Radio.Group>
                        </FormItem>
                    </div>
                    <FormItem>
                        <Button type="primary" htmlType="submit">
                            Сохранить
                        </Button>
                    </FormItem>
                </Form>
            </div>
        </CustomModal>
    );
};
